import keyMirror from 'keymirror';

export default keyMirror({
  NAVIGATE_VIEW: null,
  REQUEST_DEEP_LINK_STATUS: null,
  RECEIVE_DEEP_LINK_STATUS: null,
  RECEIVE_DEEP_LINK_ERROR: null
});
